import { getApiUrl } from '../config';

export const submitForm = async (formType, formData) => {
  try {
    const response = await fetch(getApiUrl('/submit-form'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ formType, formData }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to submit form');
    }
    return await response.json();
  } catch (error) {
    console.error('Error submitting form:', error);
    throw error;
  }
};
